
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { FaTimes } from 'react-icons/fa';
import Select from 'react-select';
import projectStore from '../../stores/projectStore';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';

function withRouter(Component) {
    return function WrapperComponent(props) {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    };
}
const AddToProjectModal = observer(
    class AddToProjectModal extends Component {
        constructor(props) {
            super(props);
            this.state = {
                projectName: '',
                clientName: '',
                projectYear: null,
                projectId: '',
                errorMessage: '',
                years: [],
                clients: [],
                projects: [], 
            };
        }

        componentDidMount() {
            projectStore.getYears().then(() => {
                this.setState({ years: projectStore.years });
            });

            document.addEventListener('keydown', this.handleKeyDown);
        }

        componentWillUnmount() {
            document.removeEventListener('keydown', this.handleKeyDown);
        }

        handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                projectStore.setAddToProjectModalVisible(false)
            }
        };

        formatYearsForSelect = () => {
            return this.state.years.map((year) => ({
                label: year,
                value: year,
            }));
        };

        formatClientsForSelect = () => {
            return this.state.clients.map((client) => ({
                label: client,
                value: client,
            }));
        };

        formatProjectsForSelect = () => {
            return this.state.projects.map((project) => ({
                label: project.project_name,
                value: project.project_id,
            }));
        };

        handleYearChange = (selectedOption) => {
            const selectedYear = selectedOption ? selectedOption.value : null;
            this.setState({ projectYear: selectedYear, clients: [], projects: [] }); 

            if (selectedYear) {
                projectStore.getClients(selectedYear).then((response) => {
                    if (response) {
                        this.setState({ clients: response });
                    } else {
                        this.setState({ errorMessage: 'Failed to load clients' });
                    }
                });
            }
        };

        handleClientChange = (selectedOption) => {
            const clientName = selectedOption ? selectedOption.value : '';
            this.setState({ clientName, projects: [] }); 

            if (clientName && this.state.projectYear) {
                projectStore.getProjects({
                    clientName,
                    year: this.state.projectYear,
                    limit: 5,
                }).then((response) => {
                    if (response) {
                        this.setState({ projects: response });
                    } else {
                        this.setState({ errorMessage: 'Failed to load projects' });
                    }
                });
            }
        };

        handleProjectChange = (selectedOption) => {
            this.setState({ projectName: selectedOption ? selectedOption.label : '' });
            this.setState({ projectId: selectedOption ? selectedOption.value : '' });
        };

        handleAddClick = () => {
            const { projectYear, clientName, projectId } = this.state;
            if (projectId) {
                this.props.navigate(`/projects/${projectYear}/${clientName}/${projectId}`);
                projectStore.setAddToProjectModalVisible(false);
            }

        };

        render() {
            const { projectYear, clientName, projectName, projectId, errorMessage } = this.state;

            return (
                <div className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 z-20">
                    <div className="flex relative flex-col w-full lg:w-[40%] h-full lg:h-[60%] py-6 px-5 lg:px-10  overflow-x-hidden bg-white shadow-lg ">
                        <div className="flex flex-col z-10">
                            <h2 className="font-bold text-xl text-[#21272A] mb-4 pt-6">{`Add To Project`}</h2>
                            <span className="font-normal text-xs text-[#21272A]">
                                Add To Project
                            </span>

                            <button
                                onClick={() => projectStore.setAddToProjectModalVisible(false)}
                                className="absolute right-5 top-4"
                            >
                                <FaTimes size={20} color="black" />
                            </button>

                            <div className="mb-4 mt-6">
                                <Select
                                    options={this.formatYearsForSelect()} 
                                    value={projectYear ? { label: projectYear, value: projectYear } : null}
                                    onChange={this.handleYearChange}
                                    placeholder="Select Project Year"
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc',
                                            },
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none',
                                        }),
                                    }}
                                />
                            </div>

                            {projectYear && (
                                <div className="mb-4">
                                    <Select
                                        options={this.formatClientsForSelect()} 
                                        value={clientName ? { label: clientName, value: clientName } : null}
                                        onChange={this.handleClientChange}
                                        placeholder="Select Client"
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                backgroundColor: '#F0EFEF',
                                                paddingTop: 5,
                                                paddingBottom: 5,
                                                boxShadow: 'none',
                                                border: '1px solid #ccc',
                                                '&:hover': {
                                                    border: '1px solid #ccc',
                                                },
                                            }),
                                            indicatorsContainer: (provided) => ({
                                                ...provided,
                                                display: 'none',
                                            }),
                                        }}
                                    />
                                </div>
                            )}

                            {clientName && projectYear && (
                                <div className="mb-4">
                                    <Select
                                        options={this.formatProjectsForSelect()} 
                                        value={projectName ? { label: projectName, value: projectName } : null}
                                        onChange={this.handleProjectChange}
                                        placeholder="Select Project"
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                backgroundColor: '#F0EFEF',
                                                paddingTop: 5,
                                                paddingBottom: 5,
                                                boxShadow: 'none',
                                                border: '1px solid #ccc',
                                                '&:hover': {
                                                    border: '1px solid #ccc',
                                                },
                                            }),
                                            indicatorsContainer: (provided) => ({
                                                ...provided,
                                                display: 'none',
                                            }),
                                        }}
                                    />
                                </div>
                            )}

                            {/* Error Message */}
                            {errorMessage && <p className="text-red-500 text-sm">{errorMessage}</p>}

                            {/* Add Button */}
                            <div className="mt-6 text-center absolute right-10 bottom-10">
                                <Button
                                    onClick={this.handleAddClick}
                                    disabled={!projectId}
                                    title={"Add"}
                                >
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
);

export default withRouter(AddToProjectModal);
